import SocialShareIconsComponent from './SocialShareIconsComponent'

export default SocialShareIconsComponent
